import React from 'react';

interface LogoImageProps {
  linkAriaLabel?: string;
}

const LogoImage = ({ linkAriaLabel }: LogoImageProps = {}) => {
  return (
    <img 
      src="/lovable-uploads/1c8d574a-a51b-4634-a910-52350c63f87b.png"
      alt="SeniorThrive - Independence at Home, Strength Together"
      className="h-12 w-auto group-hover:scale-105 transition-transform duration-300"
      loading="eager"
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default LogoImage;